{
    "UnreturnedCallsFilterSectionTitle": "Filterung nicht erwiderter Anrufe",
    "UnreturnedCallsFilterSectionDesc": "Sie können außerdem steuern, welche Arten von eingehenden Anrufen in die Berichte über „Nicht erwiderte verlorene Anrufe“ aufgenommen werden.",
    "UnreturnedCallsFilter_IncludeEscapedLabel": "Entflohene zu Anrufen einbeziehen:",
    "UnreturnedCallsFilter_IncludeDivertedOverflowedLabel": "Umgeleitete\/überlaufende Anrufe einschließen:",
    "UnreturnedCallsFilter_IncludeTransferredLabel": "Weitergeleitete Anrufe einschließen:",
    "UnreturnedCallsFilter_IncludeAllOtherLabel": "Alle anderen Anrufe einschließen:",
    "NAME": "UnreturnedCallsFilter"
}